import React from 'react';
import styled from 'styled-components';
import ReactPlayer from 'react-player/lazy';
import CloseButton from './CloseButton';

const LightboxOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(16, 69, 81, 0.95);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.xl};
`;

const LightboxContent = styled.div`
  width: 100%;
  max-width: 1200px;
  height: 85vh;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 0; // Important for flex child
  background: black;
  border-radius: ${props => props.theme.radii.sm} ${props => props.theme.radii.sm} 0 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  // This maintains the 16:9 ratio while staying within bounds
  .react-player {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
    aspect-ratio: 16/9;
    width: auto !important;
    height: 100% !important;
    padding: ${props => props.theme.spacing.sm};
  }
`;

const Thumbnails = styled.div`
  background: ${props => props.theme.colors.background};  
  border-radius: 0 0 ${props => props.theme.radii.sm} ${props => props.theme.radii.sm};
  display: flex;
  gap: ${props => props.theme.spacing.lg};
  justify-content: center;
  flex-wrap: wrap;
  padding: ${props => props.theme.spacing.md} 0;
  max-width: 100%;
  overflow-x: auto;

  /* Hide scrollbar but keep functionality */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ThumbnailButton = styled.button`
  && {
    background: ${props => {
      return props.isActive ? props.theme.colors.text : props.theme.colors.moogulbg;
    }};
    border: none;
    cursor: pointer;
    padding: ${props => props.theme.spacing.xs};
    border-radius: ${props => props.theme.radii.round};
    transition: all ${props => props.theme.transitions.default};
    flex-shrink: 0;
    position: relative;
    z-index: 1;
    
    &:hover {
      && {
        background: ${props => props.theme.colors.secondary};
      }
    }

    img {
      width: 4rem;
      height: 4rem;
      object-fit: contain;
      border-radius: ${props => props.theme.radii.round};
    }
  }
`;

const VideoLightbox = ({ isOpen, onClose, currentVideo, videos, onVideoSelect }) => {
  if (!isOpen) return null;

  return (
    <LightboxOverlay>
      <LightboxContent>
        <CloseButton 
          onClick={onClose}
          variant="dark"
          position="topRight"
          rotate
        />
        <VideoWrapper>
          <ReactPlayer
            url={currentVideo.videoUrl}
            className="react-player"
            width="100%"
            height="100%"
            controls
            config={{
              file: {
                forceHLS: true,
                hlsOptions: {
                  maxLoadingDelay: 4,
                  minAutoBitrate: 0,
                  lowLatencyMode: true
                }
              }
            }}
          />
        </VideoWrapper>
        <Thumbnails>
          {videos.map(video => (
            <ThumbnailButton
              key={video.id}
              onClick={() => onVideoSelect(video)}
              isActive={video.id === currentVideo.id}
            >
              <img src={video.icon} alt={video.label} />
            </ThumbnailButton>
          ))}
        </Thumbnails>
      </LightboxContent>
    </LightboxOverlay>
  );
};

export default VideoLightbox;